var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEC722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5476 15.6026V15.5781C16.5425 15.5864 16.5371 15.5946 16.5317 15.6026H16.5476Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6416 8.48047H9.26857C8.62849 8.48047 8.10938 8.9872 8.10938 9.61172V23.1413C8.10938 23.7655 8.62849 24.2723 9.26857 24.2723H22.6416C23.2827 24.2723 23.8018 23.7652 23.8018 23.1413V9.61172C23.8018 8.98688 23.2824 8.48047 22.6416 8.48047ZM12.8658 21.7002H10.4957V14.5695H12.8658V21.7002ZM11.6809 13.5954H11.6651C10.87 13.5954 10.3557 13.0477 10.3557 12.3635C10.3557 11.664 10.8859 11.1316 11.6965 11.1316C12.5074 11.1316 13.0062 11.664 13.022 12.3635C13.022 13.0477 12.5071 13.5954 11.6809 13.5954ZM21.4126 21.7002H19.0425V17.8845C19.0425 16.9263 18.6996 16.2722 17.842 16.2722C17.1873 16.2722 16.7974 16.7132 16.6257 17.1393C16.5631 17.2914 16.5479 17.5041 16.5479 17.7175V21.6999H14.1777C14.1777 21.6999 14.2089 15.2375 14.1777 14.5692H16.5479V15.5785C16.8628 15.0927 17.4261 14.4009 18.6843 14.4009C20.2436 14.4009 21.4129 15.4204 21.4129 17.6108L21.4126 21.7002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5f174f612b9cbedbde41a422f8e9cea1.svg";
export { ForwardRef as ReactComponent };